import React from 'react';
import { PrimeReactProvider } from 'primereact/api';
import { GitLabProvider, useGitLab } from './context/GitLabContext';
import LoginForm from './components/LoginForm';
import Dashboard from './components/Dashboard';

// PrimeReact styles
import 'primereact/resources/themes/lara-dark-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.css';

const AppContent: React.FC = () => {
  const { isAuthenticated } = useGitLab();

  return isAuthenticated ? <Dashboard /> : <LoginForm />;
};

function App() {
  return (
    <PrimeReactProvider>
      <GitLabProvider>
        <div className="app">
          <AppContent />
        </div>
      </GitLabProvider>
    </PrimeReactProvider>
  );
}

export default App;
